/* tslint:disable */
var TYourBetSPSlipMode = (function (template)
{
    "use strict";
    var api = <any>{};

    // Overrides ComboSPSlipMode
    api.updateView = function()
    {
        return "";
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
       return "";
    };

    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated)
    {
       return "";
    };

    api.buildHeader = function ()
    {
        return "";
    };
    
    /*globals TUniSlip */
    return api;
}(TUniSlip));

window.TYourBetSPSlipMode = TYourBetSPSlipMode;